import React from 'react';
import { LockTemplateModal } from './styles';
import { Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { TEMPLATE_LOCK_MODAL } from '../../../components/TemplateLock/translationValues';
const NAMESPACES = ['TEMPLATE_LOCK_MODAL'];

const TemplateLockedModal = ({ visible, onClose, lockedByUser, deletion, t }) => {
  return (
    <LockTemplateModal
      visible={visible}
      title={t(TEMPLATE_LOCK_MODAL.TEMPLATE_LOCKED_TITLE.key, TEMPLATE_LOCK_MODAL.TEMPLATE_LOCKED_TITLE.value)}
      footer={[<Button onClick={() => onClose(false)}>{t(TEMPLATE_LOCK_MODAL.LOCKED_MODAL_OK_BUTTON.key, TEMPLATE_LOCK_MODAL.LOCKED_MODAL_OK_BUTTON.value)}</Button>]}
      centered
      closable={false}
      width={700}
    >
      <svg
        width="70px"
        height="80px"
        viewBox="-10 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
        fill="#9f4c4c"
        fillRule="evenodd"
      >
        <path
          class="cls-1"
          d="M644,356h32a4,4,0,0,1,4,4v26a4,4,0,0,1-4,4H644a4,4,0,0,1-4-4V360A4,4,0,0,1,644,356Zm18,17.445V378a2,2,0,0,1-4,0v-4.555A4,4,0,1,1,662,373.445ZM670,352v-6a10,10,0,0,0-20,0v6h-6v-6a16,16,0,0,1,32,0v6h-6Z"
          id="lock"
          transform="translate(-640 -330)"
        />
      </svg>
      <h4>
        {t(TEMPLATE_LOCK_MODAL.CURRENTLY_DESIGNING_MESSAGE.key, TEMPLATE_LOCK_MODAL.CURRENTLY_DESIGNING_MESSAGE.value)}{' '} <strong>{lockedByUser}</strong>.{' '}
        {deletion
          ? t(TEMPLATE_LOCK_MODAL.DELETE_RESTRICTION_MESSAGE.key, TEMPLATE_LOCK_MODAL.DELETE_RESTRICTION_MESSAGE.value)
          : t(TEMPLATE_LOCK_MODAL.RENDERED_READ_MODE_MESSAGE.key, TEMPLATE_LOCK_MODAL.RENDERED_READ_MODE_MESSAGE.value)}
      </h4>
    </LockTemplateModal>
  );
};

export default withTranslation(NAMESPACES)(TemplateLockedModal);
